"use memo"

import { AgxSpacer, AgxTypography } from '@urbanx/agx.ui-components2'
import TaskModalStepToggle from 'pages/allTasks/TaskModal/TaskModalStepToggle'
import { TaskModalPageProps } from 'pages/allTasks/TaskModal/TaskModalPageProps'
import { splitPascalCase } from 'utils/stringUtils'

const ExchangeTaskPage = (props: TaskModalPageProps) => {
  const taskSteps = props.task.taskSteps ?? []

  return (
    <AgxSpacer direction="vertical" fill gap="spacing-2xl">
      <AgxTypography
        id="exchangeTaskTitle"
        type="heading"
        size="small"
        color="var(--text-primary)"
      >
        {splitPascalCase(props.task.category?.taskType ?? '')}
      </AgxTypography>
      <AgxSpacer direction="vertical" fill gap="spacing-xl">
        {taskSteps.map((step) => (
          <TaskModalStepToggle
            key={`${step.order}-${step.name}`}
            {...props}
            step={step}
          />
        ))}
      </AgxSpacer>
    </AgxSpacer>
  )
}

export default ExchangeTaskPage
